import React from "react";
import logoEvenely from "../assets/logo-evenely.png";
import "./PoweredByOwius.css";

export default function PoweredByOwius({ variant = "footer" }) {
	return (
		<div
			className={`powered-by-owius powered-by-owius--${variant}`}
			aria-label="Powered by Owius"
		>
			<img
				src={logoEvenely}
				alt="Evenely"
				className="powered-by-owius__logo"
			/>
			<span className="powered-by-owius__text">powered by Owius</span>
		</div>
	);
}
